const CONTEXT_HINTS = {
  'instruction-list': '💡 培训模块：我可以帮你筛选培训、解读上下架规则、分析学习进度。',
  'instruction-form': '💡 我可以帮你检查培训配置、推荐关联考试与知识库内容。',
  'instruction-bind-history': '💡 绑定历史：我可以帮你解读项目/批次绑定关系与生效范围。',
  'instruction-records': '💡 培训记录：我可以帮你分析学习进度、导出字段含义与异常数据。',
  'instruction-exam-records': '💡 答卷列表：我可以帮你解读通过率、筛选高价值样本。',
  'instruction-exam-detail': '💡 答卷详情：我可以帮你分析错题分布、知识点薄弱项。',
  'course-list': '💡 教程模块：我可以帮你梳理教程结构、检查关联培训配置。',
  'course-form': '💡 我可以帮你优化教程章节与媒体素材说明。',
  'knowledge-list': '💡 知识库模块：我可以帮你分析文档、检测内容冲突。',
}

const WELCOME_SUFFIX = '\n\n请告诉我需要什么帮助？'

function getContextHint (context) {
  return CONTEXT_HINTS[context] || '💡 考试培训管理：我可以帮你解答当前页面的操作与数据问题。'
}

export function buildWelcomeMessage (context) {
  return `你好！我是 AI 助手。\n\n${getContextHint(context)}${WELCOME_SUFFIX}`
}

function pickReply (message, context) {
  const text = (message || '').trim()
  const lower = text.toLowerCase()

  if (!text) {
    return '请输入您的问题，我会尽力解答。'
  }

  if (text.includes('上架') || text.includes('下架')) {
    return '培训上下架说明：\n• 新建培训默认为「未上架」，需手动上架后才会对用户可见\n• 已上架培训修改核心配置前建议先下架\n• 下架后已学习用户的历史记录仍会保留'
  }

  if (text.includes('导出') || lower.includes('export')) {
    return '导出说明：\n• 培训记录页支持导出当前筛选条件下的学习进度\n• 导出字段与列表列一致，适合线下分析\n• 建议先缩小筛选范围再导出，避免数据量过大'
  }

  if (text.includes('绑定') || context === 'instruction-bind-history') {
    return '绑定历史说明：\n• 记录培训与项目/批次的绑定关系\n• 绑定后对应批次用户可在任务链路中触发培训\n• 当前为一次性绑定，暂不支持解绑记录展示'
  }

  if (text.includes('答卷') || text.includes('考试') || context.includes('exam')) {
    return '答卷相关说明：\n• 仅展示已提交或进行中的考试记录\n• 详情页可查看逐题得分与正确答案对比\n• 可通过状态、来源、项目批次等条件筛选'
  }

  if (text.includes('进度') || text.includes('记录') || context === 'instruction-records') {
    return '学习进度说明：\n• 进度按教程/考试完成度综合计算\n• 可结合用户类型、来源、地区等维度筛选\n• 异常低进度用户可优先排查是否未完成前置任务'
  }

  if (text.includes('创建') || text.includes('配置') || context === 'instruction-form') {
    return '培训配置建议：\n• 先确定目标用户类型，再选择知识库/教程/考试组合\n• 零工用户可配置 App 学习中心展示与分组\n• 关联考试须为已上架状态'
  }

  if (text.includes('搜索') || text.includes('筛选')) {
    return '筛选技巧：\n• 支持培训名称、客户、分组、创建人等多维组合\n• 清空条件后点击「重置」可恢复默认列表\n• 所属用户类型可区分零工与审核实习生数据'
  }

  if (text.includes('知识库') || context === 'knowledge-list') {
    return '知识库提示：\n• 可作为培训内容来源\n• 建议保持文档结构清晰，便于后续生成题目\n• 变更知识库后需检查已关联培训是否需要更新'
  }

  if (text.includes('教程') || context.includes('course')) {
    return '教程提示：\n• 教程可独立维护，再关联到培训任务\n• 建议章节粒度适中，便于统计学习进度\n• 媒体素材上传后可在预览中核对展示效果'
  }

  return `收到您的问题：「${text}」\n\n${getContextHint(context)}\n\n（当前为模拟回复，正式 AI 接口接入后将提供更精准的回答。）`
}

export function mockSendTrainingAiMessage ({ message, context, pageTitle }) {
  return new Promise((resolve) => {
    const delay = 600 + Math.floor(Math.random() * 500)
    setTimeout(() => {
      resolve({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        role: 'assistant',
        content: pickReply(message, context || ''),
        timestamp: new Date(),
        meta: {
          context,
          pageTitle,
          mocked: true,
        },
      })
    }, delay)
  })
}



// WEBPACK FOOTER //
// ./src/views/training/utils/training-ai-assistant.mock.js